import React from "react";
import { useIntl } from "react-intl";

function About() {
  const intl = useIntl();

  return (
    <section className="about-container">
      <h1 className="about-heading">
        {intl.formatMessage({ id: "header.about" })}
      </h1>
      <div className="about-form-container">
        <p className="about-paragraph">
          {intl.formatMessage({ id: "about.part1" })}
        </p>
        <p className="about-paragraph">
          {intl.formatMessage({ id: "about.part2" })}
        </p>
      </div>
    </section>
  );
}

export default About;
